/**
 * MM Comparatif : menu swap (bouton disclosure) + remplacement AJAX des cartes.
 * Pré-charge toutes les cartes produits au chargement pour des swaps instantanés.
 */
(function () {
	var SECTION_KEY = 'mm-comparatif-card-ajax';

	/* ── Cache des réponses AJAX (handle → HTML) ───────────────────── */
	var cardCache = {};

	/* ── JSON produits embarqué dans la page ────────────────────────── */

	function getCollectionProducts(comparatifRoot) {
		var script = comparatifRoot.querySelector('script[data-mm-comparatif-products]');
		if (!script) return [];
		try { return JSON.parse(script.textContent) || []; }
		catch (e) { return []; }
	}

	/* ── Visible IDs (triplet id0,id1,id2) ─────────────────────────── */

	function getVisibleIds(comparatifRoot) {
		var raw = comparatifRoot.dataset.mmComparatifVisibleIds || '';
		var parts = raw.split(',');
		while (parts.length < 3) parts.push('');
		return parts;
	}

	function updateVisibleIdsState(comparatifRoot, slot, newProductId) {
		var parts = getVisibleIds(comparatifRoot);
		var idx = parseInt(slot, 10);
		if (idx !== 1 && idx !== 2) return;
		parts[idx] = String(newProductId);
		comparatifRoot.dataset.mmComparatifVisibleIds = parts.join(',');
	}

	/* ── Disclosure open/close ─────────────────────────────────────── */

	function setSwapOpen(swapRoot, open) {
		var btn = swapRoot.querySelector('.mm-product-card-comparatif-swap-toggle');
		var panel = swapRoot.querySelector('.mm-product-card-comparatif-swap-dropdown');
		if (!btn || !panel) return;
		btn.setAttribute('aria-expanded', open ? 'true' : 'false');
		panel.hidden = !open;
	}

	function closeAllComparatifSwaps() {
		document.querySelectorAll('.mm-product-card-comparatif-swap').forEach(function (sw) {
			setSwapOpen(sw, false);
		});
	}

	/* ── Section Rendering API ─────────────────────────────────────── */

	function pickSectionHtml(json) {
		if (!json || typeof json !== 'object') return '';
		if (json[SECTION_KEY]) return json[SECTION_KEY];
		var keys = Object.keys(json);
		for (var i = 0; i < keys.length; i++) {
			if (/comparatif/i.test(keys[i]) && /ajax/i.test(keys[i])) return json[keys[i]];
		}
		return '';
	}

	function buildFetchUrl(handle) {
		var pathPrefix =
			window.Shopify && window.Shopify.routes && window.Shopify.routes.root
				? window.Shopify.routes.root
				: '/';
		return pathPrefix + 'products/' + encodeURIComponent(handle) + '?sections=' + encodeURIComponent(SECTION_KEY);
	}

	function fetchCard(handle) {
		if (cardCache[handle]) return cardCache[handle];
		var promise = fetch(buildFetchUrl(handle))
			.then(function (r) { return r.json(); })
			.then(function (json) {
				var html = pickSectionHtml(json);
				cardCache[handle] = Promise.resolve(html);
				return html;
			});
		cardCache[handle] = promise;
		return promise;
	}

	/* ── Pré-chargement de toutes les cartes au chargement ─────────── */

	function prefetchAllCards() {
		var comparatifRoot = document.querySelector('.mm-comparatif[data-mm-comparatif-collection]');
		if (!comparatifRoot) return;

		var allProducts = getCollectionProducts(comparatifRoot);
		if (!allProducts.length) return;

		allProducts.forEach(function (product) {
			fetchCard(product.handle);
		});
	}

	/* ── Créer un item swap (bouton produit dans la liste) ─────────── */

	function createSwapItem(product) {
		var btn = document.createElement('button');
		btn.type = 'button';
		btn.className = 'mm-product-card-comparatif-swap-link mm-flex mm-align-center mm-gap-3 mm-cursor-pointer mm-w-full mm-comparatif-swap-choose';
		btn.setAttribute('data-mm-comparatif-product-handle', product.handle);

		var pic = document.createElement('picture');
		pic.className = 'mm-product-card-comparatif-swap-thumb-wrap mm-relative mm-flex-shrink-0';
		var img = document.createElement('img');
		img.src = product.image || '';
		img.alt = product.title || '';
		img.loading = 'lazy';
		img.width = 34;
		img.height = 42;
		img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
		pic.appendChild(img);

		var ref = document.createElement('p');
		ref.className = 'mm-product-infos-reference mm-product-card-comparatif-swap-reference mm-text-small mm-text-start mm-align-start';
		ref.textContent = product.title || '';

		btn.appendChild(pic);
		btn.appendChild(ref);
		return btn;
	}

	/* ── Rafraîchir les items d'un dropdown ─────────────────────────── */

	function refreshDropdownItems(panel, allProducts, visibleSet) {
		while (panel.firstChild) panel.removeChild(panel.firstChild);
		var count = 0;
		for (var i = 0; i < allProducts.length; i++) {
			if (visibleSet[String(allProducts[i].id)]) continue;
			panel.appendChild(createSwapItem(allProducts[i]));
			count++;
			if (count >= 8) break;
		}
	}

	function refreshAllDropdowns(comparatifRoot) {
		var allProducts = getCollectionProducts(comparatifRoot);
		if (!allProducts.length) return;

		var visibleIds = getVisibleIds(comparatifRoot);
		var visibleSet = {};
		for (var i = 0; i < visibleIds.length; i++) {
			if (visibleIds[i]) visibleSet[String(visibleIds[i])] = true;
		}

		var panels = comparatifRoot.querySelectorAll('.mm-product-card-comparatif-swap-dropdown');
		panels.forEach(function (panel) {
			refreshDropdownItems(panel, allProducts, visibleSet);
		});
	}

	/* ── Injecter un swap clone dans une carte ─────────────────────── */

	function injectSwapIntoCard(card, swapClone) {
		var chevronWrap = card.querySelector('.mm-product-card-comparatif-content-reference-rating-chevron');
		if (!chevronWrap) return;
		var existing = chevronWrap.querySelector('.mm-product-card-comparatif-swap');
		if (existing) existing.remove();
		chevronWrap.appendChild(swapClone);
		setSwapOpen(swapClone, false);
	}

	/* ── Event : choisir un produit dans le swap ───────────────────── */

	document.addEventListener('click', function (e) {
		var choose = e.target.closest && e.target.closest('.mm-comparatif-swap-choose');
		if (choose) {
			var comparatifRoot = choose.closest('.mm-comparatif');
			var card = choose.closest('.mm-product-card-comparatif');
			if (!comparatifRoot || !card || !comparatifRoot.dataset.mmComparatifCollection) return;

			var handle = choose.dataset.mmComparatifProductHandle;
			var slot = card.dataset.mmComparatifSlot;
			if (!handle || !slot) return;

			e.preventDefault();
			e.stopPropagation();

			var li = card.closest('li.splide__slide.mm-comparatif__slide');
			if (!li) return;

			var oldSwapEl = card.querySelector('.mm-product-card-comparatif-swap');
			var savedSwap = oldSwapEl ? oldSwapEl.cloneNode(true) : null;

			closeAllComparatifSwaps();

			choose.setAttribute('aria-busy', 'true');
			choose.disabled = true;

			fetchCard(handle)
				.then(function (html) {
					if (!html) return;

					var wrap = document.createElement('div');
					wrap.innerHTML = html;
					var newCard = wrap.querySelector('.mm-product-card-comparatif');
					if (!newCard) return;

					newCard.setAttribute('data-mm-comparatif-slot', slot);

					var newId = newCard.getAttribute('data-mm-comparatif-product-id');
					if (!newId) {
						var allProducts = getCollectionProducts(comparatifRoot);
						for (var p = 0; p < allProducts.length; p++) {
							if (allProducts[p].handle === handle) {
								newId = String(allProducts[p].id);
								newCard.setAttribute('data-mm-comparatif-product-id', newId);
								break;
							}
						}
					}

					li.innerHTML = '';
					li.appendChild(newCard);

					if (savedSwap) {
						injectSwapIntoCard(newCard, savedSwap);
					}

					if (newId) {
						updateVisibleIdsState(comparatifRoot, slot, newId);
					}

					refreshAllDropdowns(comparatifRoot);

					document.dispatchEvent(new CustomEvent('comparatif:card-swapped', { detail: { card: newCard } }));

					setTimeout(function () {
						if (window.SplideManager && typeof SplideManager.initInSection === 'function') {
							SplideManager.initInSection(comparatifRoot);
						}
					}, 200);
				})
				.catch(function (err) {
					console.error('[MM Comparatif] swap error:', err);
				})
				.finally(function () {
					if (choose && choose.parentNode) {
						choose.removeAttribute('aria-busy');
						choose.disabled = false;
					}
				});

			return;
		}

		/* ── Event : toggle du bouton swap ──────────────────────────── */

		var toggleBtn = e.target.closest && e.target.closest('.mm-product-card-comparatif-swap-toggle');
		if (toggleBtn) {
			var swapRoot = toggleBtn.closest('.mm-product-card-comparatif-swap');
			if (!swapRoot) return;
			e.preventDefault();
			var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
			if (expanded) {
				setSwapOpen(swapRoot, false);
			} else {
				closeAllComparatifSwaps();
				setSwapOpen(swapRoot, true);
			}
			return;
		}

		if (e.target.closest && e.target.closest('.mm-product-card-comparatif-swap')) return;
		closeAllComparatifSwaps();
	});

	document.addEventListener('keydown', function (e) {
		if (e.key !== 'Escape') return;
		if (!document.querySelector('.mm-product-card-comparatif-swap-toggle[aria-expanded="true"]')) return;
		closeAllComparatifSwaps();
	});

	/* ── Alignement des métriques entre les cartes ─────────────────── */
	// Construit une liste maître (union triée) de toutes les métriques visibles,
	// puis insère des lignes vides (visibility:hidden) dans les cartes qui
	// n'ont pas une métrique donnée, afin que les lignes s'alignent visuellement.

	function createPlaceholderRow(label) {
		var div = document.createElement('div');
		div.className = 'mm-product-metric mm-flex mm-gap-2';
		div.dataset.metricLabel = label;
		div.setAttribute('data-metric-placeholder', '');
		div.setAttribute('aria-hidden', 'true');
		div.style.opacity = '0.35';
		div.innerHTML =
			'<div class="mm-product-metric-info mm-flex mm-gap-2 mm-align-center mm-justify-between">' +
				'<div class="mm-product-metric-label mm-flex mm-gap-2">' +
					'<p class="mm-product-metric-label-text mm-text-small-medium">' + label + '</p>' +
				'</div>' +
				'<p class="mm-product-metric-description mm-text-medium" style="flex-shrink:0">—</p>' +
			'</div>' +
			'<div class="mm-product-metric-value mm-bg-black-200 mm-rounded-small mm-w-full mm-relative mm-overflow-hidden"></div>';
		return div;
	}

	function alignMetrics(comparatifRoot) {
		var lists = Array.from((comparatifRoot || document).querySelectorAll('.mm-product-card-comparatif-metric-list'));
		if (lists.length < 2) return;

		// 1. Union de toutes les étiquettes de métriques
		var seen = {};
		lists.forEach(function (list) {
			list.querySelectorAll('.mm-product-metric[data-metric-label]').forEach(function (row) {
				var lbl = row.dataset.metricLabel;
				if (lbl) seen[lbl] = true;
			});
		});

		var masterList = Object.keys(seen).sort(function (a, b) {
			return a.localeCompare(b, 'fr', { sensitivity: 'base' });
		});
		if (!masterList.length) return;

		// 2. Réordonner chaque carte selon la liste maître
		lists.forEach(function (list) {
			// Supprimer d'éventuels placeholders précédents
			list.querySelectorAll('[data-metric-placeholder]').forEach(function (el) { el.remove(); });

			// Construire la map label → élément existant
			var rowMap = {};
			list.querySelectorAll('.mm-product-metric[data-metric-label]').forEach(function (row) {
				rowMap[row.dataset.metricLabel] = row;
				row.remove();
			});

			// Réinjecter dans l'ordre maître (réel ou placeholder)
			masterList.forEach(function (label) {
				list.appendChild(rowMap[label] || createPlaceholderRow(label));
			});
		});
	}

	/* ── Lancer le pré-chargement ──────────────────────────────────── */

	function init() {
		prefetchAllCards();
		var root = document.querySelector('.mm-comparatif[data-mm-comparatif-collection]');
		alignMetrics(root);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('comparatif:card-swapped', function (e) {
		var root = e.detail && e.detail.card && e.detail.card.closest('.mm-comparatif');
		alignMetrics(root || document.querySelector('.mm-comparatif[data-mm-comparatif-collection]'));
	});
})();
